import { useEffect, useState } from "react";

export function usePeriodicModal(start: Date, end: Date) {
  const [open, setOpen] = useState(false);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (initialized) return;
    const now = new Date();
    if (now >= start && now <= end) {
      setOpen(true);
    }
    setInitialized(true);
  }, [start, end, initialized]);

  return { open, setOpen };
}